(function(){
  "use strict";
  /* production (E340 layout): shadow root, Liquid data, real cart, theme scroller */
  var HOST = document.getElementById("cgk-host");
  if (!HOST) return;
  if (!HOST.shadowRoot) { var tpl = HOST.querySelector("template[shadowrootmode]");
    if (tpl) { HOST.attachShadow({ mode: "open" }).appendChild(tpl.content); tpl.remove(); } }
  var ROOT = HOST.shadowRoot;
  var D = JSON.parse(document.getElementById("cgk-data").textContent);
  var LIVE = JSON.parse(document.getElementById("cgk-live").textContent);
  var P = D.product;
  P.price = LIVE.price; P.inStock = !!LIVE.inStock; P.rating = LIVE.rating; P.ratingCount = LIVE.ratingCount;
  function asset(src){ var k = String(src).replace(/^img\//, ""); return (LIVE.asset && LIVE.asset[k]) || src; }
  Object.keys(D.images).forEach(function(k){ D.images[k].src = asset(D.images[k].src); });
  D.features.forEach(function(f){ if (f.img) f.img = asset(f.img); });
  var PW = document.querySelector(".page-wrapper");
  function onScroll(fn){ addEventListener("scroll", fn, { passive: true }); if (PW) PW.addEventListener("scroll", fn, { passive: true }); }
  function topBar(){ var hh = parseFloat(getComputedStyle(document.body).getPropertyValue("--header-height")) || 0;   /* the theme sets it on <body> */
    return hh; }
  var BRAND = /CamGuard Australia/g;
  function esc(s){ return String(s).replace(/[&<>"]/g, function(c){ return {"&":"&amp;","<":"&lt;",">":"&gt;","\"":"&quot;"}[c]; }); }
  function nb(s){ return esc(s).replace(BRAND, '<span class="nb">CamGuard&nbsp;Australia</span>'); }
  function $(id){ return ROOT.getElementById(id); }
  window.C1 = { D:D, esc:esc, nb:nb, $:$, host:HOST, root:ROOT, asset:asset, onScroll:onScroll, topBar:topBar };
  var reduce = window.matchMedia("(prefers-reduced-motion: reduce)").matches;
  window.C1.reduce = reduce;
  var star = '<svg viewBox="0 0 20 20" aria-hidden="true"><path d="M10 1.6l2.6 5.3 5.8.8-4.2 4.1 1 5.8L10 14.9l-5.2 2.7 1-5.8L1.6 7.7l5.8-.8z"/></svg>';
  /* intro */
  $("p-name").textContent = P.name;
  $("p-meta").innerHTML = '<span class="cond">' + esc(P.condition) + '</span><span>Model ' + esc(P.model) + '</span>' +
    (P.rating ? '<span>' + star + ' ' + esc(P.rating) + ' <span class="sr">out of 5, from</span> (' + esc(P.ratingCount) + ' reviews)</span>' : '');
  $("sv-list").innerHTML = D.shortVersion.map(function(t){ return "<li>" + nb(t) + "</li>"; }).join("");
  /* buy bar: price only ever comes from the data layer */
  $("bb-name").textContent = P.shortName;
  $("bb-sub").innerHTML = '<span class="cond">' + esc(P.condition) + '</span> · <span class="stock">' + (P.inStock ? "In stock" : "Sold out") + '</span>';
  $("bb-rate").innerHTML = P.rating ? star.replace('<svg', '<svg style="width:13px;height:13px;vertical-align:-2px;fill:#1d1d1f"') + " " + esc(P.rating) + " (" + esc(P.ratingCount) + " reviews)" : "";
  $("bb-price").textContent = P.price;
  var toast = $("toast"), tt;
  function showToast(msg){ toast.textContent = msg; toast.classList.add("on"); clearTimeout(tt); tt = setTimeout(function(){ toast.classList.remove("on"); }, 2800); }
  window.C1.toast = showToast;
  /* real cart: press the theme's own Add to cart (drawer, count, analytics); /cart/add.js as fallback */
  var addBtn = $("add-cart");
  function themeAdd(){ return document.querySelector('product-form-component button[name="add"]'); }
  if (!P.inStock) { addBtn.textContent = "Sold out"; addBtn.disabled = true; }
  addBtn.addEventListener("click", function(){
    if (!P.inStock) return;
    var b = themeAdd();
    if (b && !b.disabled) { b.click(); return; }
    var root = (window.Shopify && Shopify.routes && Shopify.routes.root) || "/";
    addBtn.disabled = true;
    fetch(root + "cart/add.js", { method: "POST", headers: { "Content-Type": "application/json", "Accept": "application/json" },
      body: JSON.stringify({ items: [{ id: LIVE.variantId, quantity: 1 }] }) })
      .then(function(r){ if (!r.ok) throw new Error(r.status); location.href = root + "cart"; })
      .catch(function(){ addBtn.disabled = false; showToast("That didn't go through. Please use the Add to cart button at the top of the page."); });
  });
  /* footer */
  $("foot-text").innerHTML = nb(D.footer);
  $("foot-img").innerHTML = nb(D.imageNote);
  /* reveal on entry: never hides content at rest (fails open), .4s, 12px */
  window.C1.reveal = function(root){
    if (reduce || !("IntersectionObserver" in window) || !Element.prototype.animate) return;
    var els = (root || ROOT).querySelectorAll("[data-rv]");
    var io = new IntersectionObserver(function(ents){
      ents.forEach(function(e){
        if (!e.isIntersecting) return;
        io.unobserve(e.target);
        if (e.boundingClientRect.top < innerHeight * 0.5) return; /* already on screen: leave it be */
        e.target.animate([{opacity:0, transform:"translateY(12px)"},{opacity:1, transform:"none"}],
          {duration:400, easing:"cubic-bezier(.2,.7,.2,1)", delay:(+e.target.getAttribute("data-rv") || 0) * 40});
      });
    }, {rootMargin:"0px 0px 0px 0px", threshold:0});
    els.forEach(function(el){ io.observe(el); });
  };
  /* ---------- hero: sound, notification, ring (works with or without WebGL) ---------- */
  $("poster3d").alt = D.images.front.alt;
  var actx = null;
  function audio(){
    try {
      if (!actx) { var AC = window.AudioContext || window.webkitAudioContext; if (!AC) return null; actx = new AC(); }
      if (actx.state === "suspended") actx.resume();
    } catch (e) { return null; }
    return actx;
  }
  function tone(a, out, f, t, dur){
    var g = a.createGain();
    g.gain.setValueAtTime(0.0001, t);
    g.gain.exponentialRampToValueAtTime(0.5, t + 0.012);
    g.gain.exponentialRampToValueAtTime(0.15, t + 0.32);
    g.gain.exponentialRampToValueAtTime(0.0001, t + dur);
    g.connect(out);
    [[1, 1], [2, 0.3], [3, 0.09], [4.2, 0.05]].forEach(function(p, i){
      var o = a.createOscillator(), pg = a.createGain();
      o.type = "sine"; o.frequency.value = f * p[0]; pg.gain.value = p[1];
      if (i > 1) { pg.gain.setValueAtTime(p[1], t); pg.gain.exponentialRampToValueAtTime(0.0001, t + 0.3 + i * 0.05); }
      o.connect(pg); pg.connect(g); o.start(t); o.stop(t + dur + 0.05);
    });
  }
  function click(a, out, t){
    var n = Math.floor(a.sampleRate * 0.03), b = a.createBuffer(1, n, a.sampleRate), d = b.getChannelData(0);
    for (var i = 0; i < n; i++) d[i] = (Math.random() * 2 - 1) * Math.pow(1 - i / n, 3);
    var s = a.createBufferSource(), bp = a.createBiquadFilter(), g = a.createGain();
    s.buffer = b; bp.type = "bandpass"; bp.frequency.value = 2400; bp.Q.value = 1.1; g.gain.value = 0.22;
    s.connect(bp); bp.connect(g); g.connect(out); s.start(t);
  }
  function chime(){
    var a = audio(); if (!a) return;
    var t0 = a.currentTime + 0.03, out = a.createGain(), lp = a.createBiquadFilter();
    out.gain.value = 0.55; lp.type = "lowpass"; lp.frequency.value = 4800;
    out.connect(lp); lp.connect(a.destination);
    click(a, out, t0);
    tone(a, out, 659.25, t0 + 0.05, 1.5);   /* ding */
    tone(a, out, 523.25, t0 + 0.52, 2.3);   /* dong */
  }
  var notif = $("notif"), stage = $("stage3d"), nt, lastRing = 0;
  function notify(){
    notif.classList.remove("on"); void notif.offsetWidth; notif.classList.add("on");
    $("notif-live").textContent = "Notification: Front Door. Someone's at your door.";
    clearTimeout(nt); nt = setTimeout(function(){ notif.classList.remove("on"); }, 4200);
  }
  function ring(from3d){
    var now = Date.now(); if (now - lastRing < 900) return; lastRing = now;
    chime();
    stage.classList.remove("rang"); void stage.offsetWidth; stage.classList.add("rang");
    if (!from3d && window.C1.three && window.C1.three.press) window.C1.three.press();
    setTimeout(notify, 300);
  }
  window.C1.ring = ring;
  $("ring-btn").addEventListener("click", function(){ ring(false); });
  stage.querySelector(".ring-pulse").addEventListener("click", function(){ if (!stage.classList.contains("live")) ring(false); });
  stage.addEventListener("keydown", function(e){
    var t = window.C1.three; if (!t) return;
    if (e.key === "ArrowLeft") { t.nudge(-0.35); e.preventDefault(); }
    else if (e.key === "ArrowRight") { t.nudge(0.35); e.preventDefault(); }
    else if (e.key === "Enter" || e.key === " ") { ring(false); e.preventDefault(); }
  });
  /* ---------- stats ---------- */
  var SG = ["--g-cam","--g-cam","--g-cam","--g-store","--g-power","--g-night","--g-weather","--g-store"];
  $("stats").innerHTML = D.stats.map(function(st, i){
    var v = String(st.value), sp = v.indexOf(" "), val = sp > 0 ? esc(v.slice(0, sp)) + "<small>" + esc(v.slice(sp + 1)) + "</small>" : esc(v);
    return '<li class="stat" style="--g:var(' + SG[i % SG.length] + ')" data-rv="' + (i % 4) + '"><span class="stat-v gt">' + val +
      '</span><p class="stat-l">' + nb(st.label) + '</p></li>';
  }).join("");

  /* ---------- features ---------- */
  var F = {}; D.features.forEach(function(f){ F[f.id] = f; });
  function spec(k){ var v = ""; D.specs.forEach(function(g){ g.rows.forEach(function(r){ if (r[0] === k) v = r[1]; }); }); return v; }
  function statVal(i){ var v = String(D.stats[i].value), sp = v.indexOf(" "); return sp > 0 ? esc(v.slice(0, sp)) + "<small>" + esc(v.slice(sp + 1)) + "</small>" : esc(v); }
  function statBy(re){ for (var i = 0; i < D.stats.length; i++) if (re.test(D.stats[i].label)) return statVal(i); return ""; }
  window.C1.spec = spec; window.C1.statBy = statBy;
  $("f-dual-eye").textContent = F.dual.title;
  $("f-dual-body").innerHTML = nb(F.dual.body);
  $("f-dual-legend").innerHTML =
    '<li><i style="background:#1a8cff"></i><span><b>Front camera.</b> ' + nb(spec("Front camera")) + '</span></li>' +
    '<li><i style="background:#12a192"></i><span><b>Downward camera.</b> ' + nb(spec("Downward camera")) + '</span></li>' +
    '<li><i style="background:linear-gradient(135deg,#1a8cff 50%,#12a192 50%)"></i><span><b>Viewing angle.</b> ' + nb(spec("Viewing angle")) + '</span></li>';
  var cols = [
    { id: "night", g: "--g-night", big: statBy(/night/) },
    { id: "detect", g: "--g-detect", big: "Delivery Guard" },
    { id: "talk", g: "--g-talk", big: "Two-way audio" },
    { id: "storage", g: "--g-store", big: statBy(/storage/) }
  ];
  $("fcols").innerHTML = cols.map(function(c, i){
    var f = F[c.id];
    return '<article class="fcol" style="--g:var(' + c.g + ')" data-rv="' + (i % 2) + '"><h3 class="eyebrow gt">' + esc(f.title) + '</h3>' +
      '<p class="fcol-big gt">' + c.big + '</p><p class="fbody">' + nb(f.body) + '</p></article>';
  }).join("");
  $("f-power-eye").textContent = F.power.title;
  $("f-power-big").innerHTML = statBy(/battery/);
  $("f-power-body").innerHTML = nb(F.power.body);
  var pimgs = ROOT.querySelectorAll(".pimg"), segb = ROOT.querySelectorAll(".seg button");
  var pcap = { bat: D.images.batteryPack.alt, wire: D.images.wiring.alt };
  pimgs[0].alt = pcap.bat; pimgs[1].alt = pcap.wire;
  function pshow(k){
    segb.forEach(function(b){ b.setAttribute("aria-pressed", String(b.getAttribute("data-k") === k)); });
    pimgs.forEach(function(im){ im.classList.toggle("on", im.getAttribute("data-k") === k); });
    $("pcap").textContent = pcap[k] + ".";
  }
  segb.forEach(function(b){ b.addEventListener("click", function(){ pshow(b.getAttribute("data-k")); }); });
  pshow("bat");
  /* ---------- honest details + fit check ---------- */
  $("honest-list").innerHTML = D.honest.map(function(t, i){
    var k = t.indexOf(". "), lead = k > 0 ? t.slice(0, k + 1) : t, rest = k > 0 ? t.slice(k + 1) : "";
    return '<li data-rv="' + (i % 2) + '"><span><b>' + nb(lead) + '</b>' + nb(rest) + '</span></li>';
  }).join("");
  var TICK = '<svg viewBox="0 0 24 24" aria-hidden="true"><circle cx="12" cy="12" r="11" fill="#1d7a34"/><path d="M7 12.5l3.2 3.2L17.2 8.8" fill="none" stroke="#fff" stroke-width="2.2" stroke-linecap="round" stroke-linejoin="round"/></svg>';
  var CROSS = '<svg viewBox="0 0 24 24" aria-hidden="true"><circle cx="12" cy="12" r="11" fill="#c7254e"/><path d="M8.5 8.5l7 7M15.5 8.5l-7 7" stroke="#fff" stroke-width="2.2" stroke-linecap="round"/></svg>';
  $("fit-ok").innerHTML = D.worksWith.map(function(t){ return "<li>" + TICK + '<span><span class="sr">Works: </span>' + nb(t) + "</span></li>"; }).join("");
  $("fit-no").innerHTML = D.notWith.map(function(t){ return "<li>" + CROSS + '<span><span class="sr">Not compatible: </span>' + nb(t) + "</span></li>"; }).join("");

  /* ---------- in the box ---------- */
  var xis = [].slice.call(ROOT.querySelectorAll("#xbox .xi")), xbox = $("xbox");
  xis.forEach(function(el, i){
    el.querySelector("figcaption").innerHTML = '<span class="xn" aria-hidden="true">' + (i + 1) + '</span><span>' + nb(D.inBox[i]) + '</span>';
  });
  xis[0].querySelector("img").alt = D.images.front.alt;
  $("notinc").innerHTML = D.notIncluded.map(function(t){ return "<li>" + nb(t) + "</li>"; }).join("");
  if (!reduce && "IntersectionObserver" in window) {
    var xraf = 0, xon = false;
    var xmeasure = function(){
      var a0 = xis[0].querySelector(".xa").getBoundingClientRect(), cx = a0.left + a0.width / 2, cy = a0.top + a0.height / 2;
      xbox.style.setProperty("--e", "1");
      xis.slice(1).forEach(function(el, i){
        var a = el.querySelector(".xa"), r = a.getBoundingClientRect();
        a.style.setProperty("--dx", (cx - (r.left + r.width / 2)).toFixed(1) + "px");
        a.style.setProperty("--dy", (cy - (r.top + r.height / 2)).toFixed(1) + "px");
        a.style.setProperty("--r", ((i % 2 ? 1 : -1) * (8 + i * 3)) + "deg");
      });
    };
    var xstep = function(){
      xraf = 0;
      var r = xbox.getBoundingClientRect(), v = innerHeight, e = Math.max(0, Math.min(1, (v * 0.95 - r.top) / (v * 0.5)));
      e = e * e * (3 - 2 * e);
      xbox.style.setProperty("--e", e.toFixed(3));
    };
    var xkick = function(){ if (xon && !xraf) xraf = requestAnimationFrame(xstep); };
    new IntersectionObserver(function(es){ xon = es[0].isIntersecting; if (xon) { xmeasure(); xstep(); } }, { rootMargin: "100px 0px" }).observe(xbox);
    onScroll(xkick);
    addEventListener("resize", function(){ if (xon) { xmeasure(); xstep(); } });
  }

  /* ---------- setup, delivery, faq ---------- */
  $("steps").innerHTML = D.setup.map(function(st, i){
    return '<li class="step" data-rv="' + (i % 4) + '"><span class="step-n gt">' + (i + 1) + '</span><h3>' + nb(st.t) + '</h3><p>' + nb(st.d) + '</p></li>';
  }).join("");
  var wm = /(\d+)-month/.exec(D.warranty), rm = /(\d+) days/.exec(D.returns);
  var DC = [
    { g: "--g-cam", h: "Dispatch and delivery", big: D.dispatchShort, body: [D.dispatch, D.shipping] },
    { g: "--g-power", h: "Warranty", big: wm ? wm[1] + " months, ours" : "", body: [D.warranty] },
    { g: "--g-night", h: "Returns", big: rm ? rm[1] + " days, change of mind" : "", body: [D.returns] },
    { g: "--g-store", h: "Condition", big: P.condition, body: [D.condition] }
  ];
  $("dcols").innerHTML = DC.map(function(c, i){
    return '<article class="dcol" style="--g:var(' + c.g + ')" data-rv="' + (i % 2) + '"><h3>' + esc(c.h) + '</h3><p class="dbig gt">' + esc(c.big) + '</p>' +
      c.body.map(function(t){ return '<p class="dt">' + nb(t) + '</p>'; }).join("") + '</article>';
  }).join("");
  $("faq-list").innerHTML = D.faq.map(function(f){ return '<details><summary>' + nb(f.q) + '</summary><p class="ans">' + nb(f.a) + '</p></details>'; }).join("");
  /* Simple view: its "Specifications" jump link now goes to the site's own spec table below */
  document.addEventListener("click", function(e){
    var a = e.target && e.target.closest && e.target.closest('.cgk-pane-simple a[href="#eu-specifications"], .cgk-pane-simple a[href="#kn-specs"]');
    var t = a && document.querySelector(".product-specifications");
    if (!t) return;
    e.preventDefault(); t.style.scrollMarginTop = (topBar() + 12) + "px";
    t.scrollIntoView({ behavior: reduce ? "auto" : "smooth", block: "start" });
    /* sections above can change height as they render during the glide, so settle on the table afterwards */
    var settle = function(){ if (Math.abs(t.getBoundingClientRect().top - topBar() - 12) < 8) return;
      var h = document.documentElement, sb = h.style.scrollBehavior; h.style.scrollBehavior = "auto";
      t.scrollIntoView({ block: "start" }); h.style.scrollBehavior = sb; };
    setTimeout(settle, 1300); setTimeout(settle, 2300);
  });

  /* ---------- Fun view = The Parcel Daycare skin (27.09.2026): the outer tab radios switch .cgk-fun on the host ---------- */
  (function(){
    var host = document.getElementById("cgk-host"), rf = document.getElementById("cgk-v-simple"), rs = document.getElementById("cgk-v-tour"), el = document.getElementById("cgk-fun");
    if (!host || !rf || !el) return;
    var FUN = JSON.parse(el.textContent), R = C1.root, ORIG = null;
    function nodes(){
      var out = [];
      Object.keys(FUN.text).forEach(function(k){ var p = k.split(":"), list = R.querySelectorAll(p[0]), n = list[p[1] ? +p[1] : 0]; if (n) out.push([n, FUN.text[k], true]); });
      [].slice.call(R.querySelectorAll("#stats .stat-l")).forEach(function(n, i){ if (FUN.stats[i]) out.push([n, nb(FUN.stats[i]), true]); });
      [].slice.call(R.querySelectorAll("#fcols .fcol h3")).forEach(function(n, i){ if (FUN.fcols[i]) out.push([n, esc(FUN.fcols[i]), true]); });
      var fi = $("foot-img"); if (fi) out.push([fi, fi.innerHTML + nb(FUN.imageNote), true]);
      return out;
    }
    function apply(on){
      var list = nodes();
      if (!ORIG) ORIG = list.map(function(x){ return x[0].innerHTML; });
      list.forEach(function(x, i){ var v = on ? x[1] : ORIG[i]; if (x[0].innerHTML !== v) x[0].innerHTML = v; });
      if (on) {
        if (!document.getElementById("cgk-fun-font")) { var lk = document.createElement("link"); lk.id = "cgk-fun-font"; lk.rel = "stylesheet";
          lk.href = "https://fonts.googleapis.com/css2?family=Fredoka:wght@500;600&display=swap"; document.head.appendChild(lk); }
        var hi = R.getElementById("fun-hero-img"); if (hi && !hi.getAttribute("src")) { hi.setAttribute("alt", FUN.hero.alt); hi.setAttribute("src", asset(FUN.hero.img)); }
      }
      host.classList.toggle("cgk-fun", on); C1.funOn = on;
      if (C1.night && C1.night.setFun) C1.night.setFun(on);
    }
    rf.addEventListener("change", function(){ apply(rf.checked); });
    if (rs) rs.addEventListener("change", function(){ apply(rf.checked); });
    if (rf.checked) apply(true);
  })();

  window.C1.reveal();
})();
